// extracted by css-extract-rspack-plugin
export default {"cls1":"RatingCard-cls1_hMH","cls2":"RatingCard-cls2_q6J RatingCard-cls1_hMH","variant-corex":"RatingCard-variant-corex_L5n"};